export const commandTypes = {
  autoUpdate: 'auto-update-type',
};
